import React from 'react';

/**
 * A consistent informational icon used to indicate that a field or action is locked.
 * Usually paired with a tooltip to explain why a specific value (like a Case ID)
 * cannot be edited.
 *
 * @component
 * @example
 * ```tsx
 * <LockedInfoIcon className="text-gray-900" title="This field is locked" />
 * ```
 * * @param {React.SVGProps<SVGSVGElement>} props - Standard SVG attributes.
 * @param {string} [props.className] - Optional Tailwind or CSS classes for styling (e.g., colors, margins).
 * @param {number|string} [props.width=18] - The width of the icon in pixels.
 * @param {number|string} [props.height=18] - The height of the icon in pixels.
 */
export const LockedInfoIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  width = 18,
  height = 18,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    width={width}
    height={height}
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);
